'use client';
import type { FlexibleFormVariant } from './FlexibleFormBase';
import { hasRichTextContent } from '@/packages/richText/utils';
import { createDefaultFlexibleFormVariant } from './FlexibleFormDefaultVariant';
import { createPromoCodeEntryVariant } from './FlexibleFormPromoCodeEntryVariant';
import { createWidgetFormLayoutConfig } from './WidgetForm';

interface FlexibleFormLayoutConfigArgs {
    asset: SiteFlexibleForm;
    nestedForm: boolean;
    toggleForm: boolean;
}

export function createFlexibleFormLayoutConfig({
    asset,
    nestedForm,
    toggleForm,
}: FlexibleFormLayoutConfigArgs): Pick<FlexibleFormVariant, 'styles' | 'submitButtonFitting' | 'renderContent'> {
    const formType = asset.fields.type.toLowerCase();
    const presentationStyles = asset.fields.presentation?.styles;
    const isCenter = presentationStyles?.alignment === 'Centre';
    const hasHeadlineContent = hasRichTextContent(asset.fields.headline);
    const variantFactoryArgs = {
        asset,
        nestedForm,
        toggleForm,
        hasHeadlineContent,
        isCenter,
    };

    if (formType === 'promocodeentry') {
        return createPromoCodeEntryVariant(variantFactoryArgs);
    }

    if (formType === 'widgetform-nflsignup') {
        return createWidgetFormLayoutConfig(asset);
    }

    return createDefaultFlexibleFormVariant(variantFactoryArgs);
}
